import { ContentType} from "./common";
import { Media } from "./media";

export interface StreamCard {
  id: string;
  name: string;
  icon: Media;
  createdDate?: Date;
  modifiedDate?: Date;
}

export interface AssetCard {
  id: string;
  name: string;
  icon: Media;
  progress?: number;
  createdDate?: Date;
  modifiedDate?: Date;
}

export interface CollectionCard {
  id: string;
  name: string;
  icon: Media;
  assets?: number;
  sections: number;
}

export interface PromotedContent {
  id: string;
  type: ContentType;
  description?: string;
}

//Actions and Reducer
export interface FetchLayoutRequest {
  id: string;
}

export interface HubLayout {
  id: string;
  name: string;
  empty?: boolean;
  customLayout?: boolean;
  userDefined?: boolean;
  userGroups?: string[] | null;
  rows: HubLayoutRow[];
}

export interface HubLayoutRow {
  columns: HubLayoutColumn[];
}

export interface HubLayoutColumn {
  width: number;
  section: HubLayoutSection;
}

export interface HubLayoutSection {
  id?: string;
  tempId?: string;
  title: string;
  entityType: string;
  layoutStyle: string;
  cardStyle: string;
  showFilter?: boolean;
  userDefined?: boolean;
  smartFilter?: string;
  items?: any;
}

export enum CreateAssetFileType {
  PDF = "PDF",
  PPTX = "PPTX"
}

export enum PageViewLayout {
  list_view = "LIST_VIEW",
  fullscreen = "FULLSCREEN",
  grid_view = "GRID_VIEW"
}


export interface UpdateHubSectionRequest {
  data : HubLayoutColumn[];
  rowIndex: number;
  create : boolean;
}

export interface CreateHubSectionRequest {
  data : HubLayoutColumn[];
  rowIndex: number;
}

export interface CreateHubSectionResponse {
  response: any;
  rowIndex: number;
  create : boolean;
}

export interface UpdateHubSectionResponse { 
  response: any;
  rowIndex: number;
  create : boolean;
}
//notifications

export interface Icon{
  full: string;
  thumbnail: string
}
export interface Notification {
  title: string;
  id: number;
  icon?: Icon ;
  message: string;
  url?: string; 
  createdDate: string; 
  userName: string;
  read: boolean;
  timeAgo: string;
  profileImage: string;
  totalEvents: number
}

export interface FetchNotificationsRequest {
  page: number;
}

export interface FetchNotificationResponse {
  currentPage: number;
  records: Notification[];
  totalPages: number;
  totalRecordsCount: number;
}

export interface FetchNotificationErrorResponse{
  error: any;
}


export interface DeleteNotificationResponse{
  deleting: string
}

export interface DeleteNotificationErrorResponse{
  error: any;
}

export interface UpdateNotificationResponse{
  deleting: string
}
export interface UpdateNotificationErrorResponse{
  error: any;
}

export type ISectionDirection = "Up" | "Down";